import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import * as types from '../../../constants/actionTypes';
import PropTypes from 'prop-types'
import Drawer from '../../Common/Drawer/Drawer';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../Common/Notification';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';

export class AssignTasksDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            jobTitles: [],      // { jobTitleId, name, taskCount, userId }
            users: [],          // { id, name } 
            isLoading: false
        };
    }

    componentDidMount = async () => {
        await this.loadFilters();
    }

    loadFilters = async () => {

        this.setState({ isLoading: true });
        try {
            const response = await this.props.locationDashboardActions.getTaskAssignmentFilters(this.props.locationKey);
            if (response.type === types.LOAD_TASK_ASSIGNMENT_FILTERS_SUCCESS) {
                this.setState({
                    jobTitles: response.payload.jobTitles,
                    users: response.payload.users
                });
            } else if (response.type === types.LOAD_TASK_ASSIGNMENT_FILTERS_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }            

    }

    onSaveClick = async () => {    

        // only send the ones that had an assignment
        const assignedJobTitles = this.state.jobTitles.filter(m => m.userId !== undefined);

        if(assignedJobTitles.length === 0){
            Notification("info", "", "There are no changes to save.");
            return;
        }

        this.setState({ isLoading: true });

        try {
            const response = await this.props.locationDashboardActions.saveTaskAssignments(this.props.locationKey, assignedJobTitles);
            if (response.type === types.SAVE_TASK_ASSIGNMENTS_SUCCESS) {
                Notification("success", "", response.payload.tasksModified + " Assignments made successfully");
                this.props.onComplete();
            } else if (response.type === types.SAVE_TASK_ASSIGNMENTS_FAILURE) {
                Notification("error", "Error", response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ isLoading: false }); 
        }       

    }

    assignUserToJobTitle = (userId, jobTitle) => {

        // make sure we have a valid user selected
        const user = this.state.users.find(m => m.id === userId);
        if(!user) { return; }

        // find the job title being updated
        const updatedJobTitleIndex = this.state.jobTitles.findIndex(m => m.jobTitleId === jobTitle.jobTitleId);

        if(updatedJobTitleIndex >= 0){
            // create a new copy of the array and set the userId for the jobTitle
            let updatedJobTitles = this.state.jobTitles.slice();
            updatedJobTitles[updatedJobTitleIndex].userId = parseInt(userId);

            this.setState({
                ...this.state.jobTitles,
                updatedJobTitles
            })            
        }

    }

    render() {

        return (
            <Drawer isWide={true} title='Assign Tasks' onSaveClick={this.onSaveClick} saveText='Save' onCancelClick={this.props.onCancel}>
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="bulk-assign-task-drawer">
                        <div className="mb-4">The Suggested Job Titles listed below have tasks that are not assigned to someone on your team. You may assign someone to one or more of these by using the drop-downs below.</div>
                        {this.state.jobTitles && this.state.jobTitles.length > 0 &&
                            <Fragment>
                                <div className="row mb-1">
                                    <div className="col-5 text-end"><strong>Suggested Job Title</strong></div>
                                    <div className="col-1 text-center"><strong>#Tasks</strong></div>
                                    <div className="col-6"><strong>Reassign To</strong></div>                                    
                                </div>
                                {this.state.jobTitles.map(jobTitle => {
                                    return (
                                        <div key={jobTitle.name} className="row">
                                            <div className="col-5 text-end mt-2">{jobTitle.name}</div>
                                            <div className="col-1 text-center mt-2">{jobTitle.taskCount}</div>
                                            <div className="col-6">
                                                <MultiSelectBox 
                                                    name="user"
                                                    idField="id"
                                                    valueField="name"
                                                    options={this.state.users}
                                                    selectedValues={(jobTitle.userId) ? jobTitle.userId.toString() : ""}
                                                    onChange={(id) => this.assignUserToJobTitle(id, jobTitle)}
                                                    isMulti={false}
                                                />                                            
                                            </div>
                                        </div>
                                    );
                                })}                                
                            </Fragment>
                        }
                    </div>
                </LoadingIndicator>
            </Drawer>            
        )
    }
}

AssignTasksDrawer.propTypes = {
    locationDashboardActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    locationKey: PropTypes.string.isRequired
};


export default connect(null, null)(AssignTasksDrawer);